import React, { FC } from "react";

import { Avatar } from "components/core";
import { Insurer_insurer } from "_graphql/queries/__generated__/Insurer";
import { Offer_findSingleOffer } from "_graphql/queries/__generated__/Offer";
import _ from "lodash";

type Props = {
    offer: Offer_findSingleOffer | null | undefined;
};

const OfferView: FC<Props> = ({ offer }) => {
    const offerDetails =
        JSON.parse(offer?.offer_detail?.offer_details || "[]") || [];
    return (
        <div className="space-y-6 divide-y divide-gray-200">
            <div>
                <span className="text-xs  text-secondary">
                    Offer Information
                </span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div className="col-span-2">
                        <span className="block text-sm  text-secondary">
                            Cedant Name
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.insurer?.insurer_company_name || "N/A"}
                        </div>
                    </div>
                    <div className=" gap-6 mt-2">
                        <div>
                            <span className="block text-sm  text-secondary">
                                Business Name
                            </span>
                            <div className="mt-1 block w-full sm:text-sm text-primary">
                                {offer?.classofbusiness?.business_name || "N/A"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Business Class Details
                </span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    {offerDetails?.map((detail: any, idx: number) => (
                        <div>
                            <span className="block text-sm  text-secondary">
                                {detail.keydetail}
                            </span>
                            <div className="mt-1 block w-full sm:text-sm text-primary">
                                {detail?.value || "N/A"}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">Offer Details</span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            Policy Number
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.offer_detail?.policy_number || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Insured
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.offer_detail?.insured_by || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Rate
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.rate || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Premium
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.premium || "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Facultative Offer
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.facultative_offer || "N/A"} %
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Commission
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.commission || "N/A"} %
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Brokerage
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.brokerage || "N/A"} %
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            Currency
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.offer_detail?.currency || "N/A"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">
                    Period of Insurance
                </span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div>
                        <span className="block text-sm  text-secondary">
                            From
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.offer_detail?.period_of_insurance_from ||
                                "N/A"}
                        </div>
                    </div>
                    <div>
                        <span className="block text-sm  text-secondary">
                            To
                        </span>
                        <div className="mt-1 block w-full sm:text-sm text-primary">
                            {offer?.offer_detail?.period_of_insurance_to ||
                                "N/A"}
                        </div>
                    </div>
                </div>
            </div>
            <div className="pt-6">
                <span className="text-xs  text-secondary">Comment</span>
                <div className="grid grid-cols-3 gap-6 mt-2">
                    <div className="col-span-3">
                        <div
                            className="mt-1 block w-full sm:text-sm prose prose-lg"
                            dangerouslySetInnerHTML={{
                                __html:
                                    offer?.offer_detail?.offer_comment || "N/A",
                            }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OfferView;
